<div class="row page-header">
    <div class="col-12">
        <h1>Employee Assigned Assets <small>View assets and small tools assigned to users directly and via trucks</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()" style="margin-bottom: 10px">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Employee Assigned</a>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Unassigned</a>
        </li>
    </ul>
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Employee Assets'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid id="mainGrid" #mainGrid appAutoSize (initialized)="grid.initialize(mainGrid)" [itemsSource]="grid.view">
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Asset'" [binding]="'asset'" [minWidth]="200" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Description'"
                            [binding]="'assetDesc'"
                            [minWidth]="200"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Category'"
                            [binding]="'assetCategory'"
                            [minWidth]="200"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Device'"
                            [binding]="'uddevicename'"
                            [minWidth]="200"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Identifier'"
                            [binding]="'identifier'"
                            [minWidth]="200"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'OS Install'"
                            [binding]="'osInstallDate'"
                            [minWidth]="120"
                            [format]="'MM/dd/yyyy'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Unassiged Location'"
                            [binding]="'unassignLoc'"
                            [minWidth]="200"
                            [width]="'*'"
                            [visible]="active === 2"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Employee'"
                            [binding]="'employeeName'"
                            [minWidth]="200"
                            [width]="'*'"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Employee Active'"
                            [binding]="'employeeActive'"
                            [width]="120"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'HrRef'"
                            [binding]="'hrref'"
                            [format]="'d'"
                            [width]="85"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'On Truck'"
                            [binding]="'truck'"
                            [width]="100"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Date Out'"
                            [binding]="'dateOut'"
                            [width]="120"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Memo Out'"
                            [binding]="'memoOut'"
                            [minWidth]="250"
                            [width]="'1.5*'"
                            [visible]="active === 1"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
